<form class="form-factory-container">
  <div class="audit-query-grid-filters__filters-container">
    <div class="audit-query-grid-filters__filter-container audit-query-grid-filters__filter-container--input">
      <form-factory [formGroup]="formGroupGeneralFilters" [model]="projectTypesInput"
        (onChange)="projectTypeSelectionChange($event)">
      </form-factory>
    </div>
    <div *ngIf="showProjectList" class="audit-query-grid-filters__filter-container audit-query-grid-filters__filter-container--input">
      <form-factory [formGroup]="formGroupGeneralFilters" [model]="projects"
        (onChange)="projectSelectionChange($event)">
      </form-factory>
    </div>

    <ng-container *ngIf="isHedisProjectType">
      <div class="audit-query-grid-filters__filter-container audit-query-grid-filters__filter-container--input">
        <form-factory [formGroup]="formGroupQualityFilters" [model]="measures"
          (onChange)="measureSelectionChange($event)">
        </form-factory>
      </div>
      <div class="audit-query-grid-filters__filter-container audit-query-grid-filters__filter-container--input">
        <form-factory [formGroup]="formGroupQualityFilters" [model]="numerators">
        </form-factory>
      </div>
      <div class="audit-query-grid-filters__filter-container audit-query-grid-filters__filter-container--input">
        <form-factory [formGroup]="formGroupQualityFilters" [model]="complianceCodes">
        </form-factory>
      </div>
    </ng-container>
    <ng-container *ngIf="isRiskProjectType">
      <div class="audit-query-grid-filters__filter-container audit-query-grid-filters__filter-container--input">
        <form-factory [formGroup]="formGroupRiskFilters" [model]="enrolleeInput"
          (onChange)="enrolleeSelectionChange($event)">
        </form-factory>
      </div>
      <div class="audit-query-grid-filters__filter-container audit-query-grid-filters__filter-container--input">
        <form-factory [formGroup]="formGroupRiskFilters" [model]="hccInput">
        </form-factory>
      </div>
      <div class="audit-query-grid-filters__filter-container audit-query-grid-filters__filter-container--input">
        <form-factory [formGroup]="formGroupRiskFilters" [model]="icdCodeInput">
        </form-factory>
      </div>
      <div class="audit-query-grid-filters__filter-container audit-query-grid-filters__filter-container--input">
        <form-factory [formGroup]="formGroupRiskFilters" [model]="vrcInput">
        </form-factory>
      </div>

    </ng-container>






    <div class="audit-query-grid-filters__filter-container audit-query-grid-filters__btns">
      <app-button class="header-button" (onClick)="applyFilters()" [disabled]="!isApplyButtonDisabled" text="APPLY">
      </app-button>
    </div>
    <div class="audit-query-grid-filters__filter-container audit-query-grid-filters__btns">
      <app-button (onClick)="clearFilters(true, projectType)" class="reset" text="RESET" styleClass="ui-button-secondary">

      </app-button>
    </div>
  </div>
</form>